<div id="login-component" class="component-inner-wrapper login-component-class">
  <main class="main-content" style="background: #FFF url('Logo_min.png') no-repeat bottom center;background-size: contain;">
    <div class="container">
      <div class="login_wrapper">
        <div class="login-container">
          <div class="logo-placeholder">
            <img src="mc_logo.png" />
          </div>
          <p *ngIf="ssoErrorMessage" class="sso-error-message">{{ ssoErrorMessage }}</p>
          <a
            href="javascript:void(0)"
            class="microsoft-button"
            [class.microsoft-button--loading]="isSsoLoading"
            [attr.aria-disabled]="isSsoLoading"
            (click)="login()"
          >
            <img *ngIf="!isSsoLoading" src="microsoft_login.png" alt="Sign in with Microsoft" />
            <mat-spinner *ngIf="isSsoLoading" diameter="28"></mat-spinner>
          </a>
        </div>
      </div>
    </div>
    <!-- <div style="position: absolute; display: block; bottom: 0;  width: 100%;max-height: 250px;min-height: 250px; background: #FFF url('Logo_min.png') no-repeat top center;background-size: cover;"></div> -->
  </main>
</div>
